/**
 * "Try another account" account picker shown on 404 / not found states.
 *
 * When an account accesses a deep link or resource it doesn't have permissions
 * for, it allows switching to another signed-in account in THIS tab without
 * navigating away from the target URL.
 */

import { For, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { useI18n } from "@/providers/i18n-provider";
import { useAccounts } from "./use-accounts";
import { Button } from "@/components/ui/button";
import { User } from "@fleet/icons";

export function TryAnotherAccount() {
  const { t } = useI18n();
  const { accounts, activeAccount, switchHere } = useAccounts();

  const otherAccounts = () => accounts().filter((a) => a.userId !== activeAccount()?.userId);

  return (
    <Show when={otherAccounts().length > 0}>
      <div class="mt-6 flex flex-col items-center gap-3" data-testid="try-another-account">
        <p class="text-xs text-muted-foreground">
          {t(msg`Signed in with more than one account? Try another one:`)}
        </p>
        <div class="flex flex-wrap items-center justify-center gap-2">
          <For each={otherAccounts()}>
            {(account) => (
              <Button
                variant="outline"
                size="sm"
                class="gap-1.5 text-xs"
                onClick={() => void switchHere(account.userId)}
                data-testid={`try-account-${account.userId}`}
              >
                <User class="h-3.5 w-3.5" />
                {account.displayName || account.email || t(msg`Guest`)}
              </Button>
            )}
          </For>
        </div>
      </div>
    </Show>
  );
}
